<template>
  <div class="card assign pricing-card">
    <div  class="row">


      <div class="col-1" :style="{width:'120px' ,height:'120px' }">
             <cHotelThumbnail v-if="!isLabel&&roomObj" :imgURL='(roomObj.imageBaseurl && roomObj.imageUrlLow)?roomObj.imageBaseurl + roomObj.imageUrlLow :null' >

         </cHotelThumbnail>
          <cHotelThumbnail v-if="isLabel" :imgURL='(hotelObj.mainImageUrl)?hotelObj.mainImageUrl :null' >

         </cHotelThumbnail>
      </div>
      <div class="col">
        <h2 v-if="roomObj && roomObj.roomname">{{roomObj.roomname}}</h2>
        <strong v-if="hotelObj" class="c-gray">{{hotelObj.hotelName}}</strong>
      </div>

      <div class="label-badge col ml-auto">
        <h4 class="text-center" v-if="roomObj && roomObj.roomtypes">{{roomObj.roomtypes}}</h4>
        
      </div>

      <p v-if="!isLabel" class="v-center field-wrapper required-field">
        <label>{{$t('cRoomInfoBox.ratePlan')}}</label>
      </p>

      <div v-if="!isLabel"  class="col-6">
        <ValidationProvider :rules="'required'" v-slot="{ errors }">
          <multiselect v-if="GET_RATE_PLAN && GET_RATE_PLAN.length"
          :disabled='isDisabled'
            v-model="selRatePlan"
            label="name"
            :allow-empty="false"
            :options="GET_RATE_PLAN"
            :track-by="'id'"
            :showLabels="false"
            :placeholder="$t('cRoomInfoBox.ratePlanPl')"
            v-on:input="onSelRatePlan"
          >
            <template #noResult>
              <strong>{{$t('cRoomInfoBox.listEmpty')}}</strong>
            </template>
          </multiselect>
          <div v-if="errors && errors[0]" class="invalid-feedback icon">
            <span>{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>
     
        <div v-else class="label-badge col ml-auto">
        <h4 class="text-center" v-if="selRatePlan && selRatePlan.name">{{selRatePlan.name}}</h4>
        
     
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { ValidationProvider } from "vee-validate";
import Multiselect from "vue-multiselect";
import Logger from "../../../../services/logger";
import { LOG_TYPE } from "../../../../config/API_DATA";
import { COMPONENT_NAME } from "../../../../util/constants";
import BaseConfiguration from "../../../../config/base";
import cHotelThumbnail from './cHotelThumbnail'
export default {
  name:COMPONENT_NAME.C_ROOM_INFO_BOX,
  components: {
    ValidationProvider,
    Multiselect,
    cHotelThumbnail
  },
  props: {
    hotelObj: {
      type: Object,
      default: null
    },
    roomObj: {
      type: Object,
      default: null
    },
    selValue:{
      type: Object,
      default: null
    },
     isLabel:{
      type: Boolean,
      default: false
    },
    isDisabled:{
      type:Boolean,
      default:false 
    }
  },
  data: () => {
    return {
      selRatePlan: null
    };
  },
  computed: {
    ...mapGetters("sHotelInfo", {
      GET_RATE_PLAN: "GET_RATE_PLAN",

    }),
    ...mapGetters("sRatePlan", {
      GET_SEL_RATE_PLAN: "GET_SEL_RATE_PLAN"
    }),
  },
  created(){
      try {
        if (BaseConfiguration.isDebug) console.log("created");
        if(this.selValue){
        this.selRatePlan=this.selValue;
        }else if(this.GET_SEL_RATE_PLAN){
         this.selRatePlan=this.getRatePlanObj(this.GET_SEL_RATE_PLAN);
        }else if(this.GET_RATE_PLAN&&this.GET_RATE_PLAN[0]){
          this.selRatePlan=this.GET_RATE_PLAN[0];
        }
       
               this.onSelRatePlan(this.selRatePlan);
        
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_ROOM_INFO_BOX,
          "error in created",
          err.toString(),
          "created",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
  },
  methods: {
      ...mapActions("sTariff", {
      SET_SEL_RATE_PLAN: "SET_SEL_RATE_PLAN"
    }),
     getRatePlanObj(pRatePlan) {
      let retValue = null;
      try {
        if (BaseConfiguration.isDebug) console.log("getRatePlanObj");
        if (this.GET_RATE_PLAN &&pRatePlan.id) {
          for (let i = 0; i < this.GET_RATE_PLAN.length; i++) {
            if (this.GET_RATE_PLAN[i].id == pRatePlan.id) {
              retValue = this.GET_RATE_PLAN[i];
              break;
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TARIFF_NEW,
          "error in getRatePlanObj",
          err.toString(),
          "getRatePlanObj",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    onSelRatePlan(pRatePlan) {
      try {
        if (BaseConfiguration.isDebug) console.log("onSelRatePlan");
        if(pRatePlan){
                  this.SET_SEL_RATE_PLAN(pRatePlan);

        }
        this.$emit("getSelRatePlan", pRatePlan);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_ROOM_INFO_BOX,
          "error in onSelRatePlan",
          err.toString(),
          "onSelRatePlan",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    }
  }
};
</script>
<style scoped>
 p.required-field label::after {
    content: "*";
    color: red;
  }
.label-badge{
    background:lightgray;
    height: 35px;
    line-height: 22px;
    border-radius: 22px;
    padding: 0 5px;
    font-size: .857em;
    color: black;
    font-weight: 500;
}
</style>